// Must precede every other import: the instrumentations patch XMLHttpRequest at install time.
import "./telemetry";
import "./session-replay";
import { bootstrapApplication } from "@angular/platform-browser";
import { registerLicense } from "@syncfusion/ej2-base";
import { AppComponent } from "app/app.component";
import { appConfig } from "app/app.config";
import { environment } from "environments/environment";

// https://ej2.syncfusion.com/angular/documentation/licensing/license-key-registration/#register-syncfusion-license-key-in-the-project
registerLicense(environment.SyncfusionLicenseKey);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
